module.exports = __webpack_public_path__ + "img/2-34-7.61d422ea.png";